import { ScrollView } from "../../components";
import { View, Text, Platform } from "react-native";
import CalendarClockIcon from "../../svgs/CalendarClockIcon";
import ClockIcon from "../../svgs/ClockIcon";
import { Divider } from "react-native-paper";
import { formatDate } from "../../utils/dateUtils";
import ListIcon from "../../svgs/ListIcon";
import AwardIcon from "../../svgs/Award";
import { VideoPaneProps } from "../VideosListScreen/types";
import { renderAssessmentButton } from "./utils";
import { renderVideoStatusChip } from "../VideosListScreen/utils";

export default function VideoPane({ videoData, selectPane, completedDate }: VideoPaneProps) {
  const handleAssessmentPress = () => {
    selectPane({ id: "assessment" });
  };
  const creditCategoryMap = {
    EDUCATION: "Education",
    PLAYER_ENGAGEMENT: "Player Engagement",
    MEETINGS: "Meetings",
    NATIONAL_SURVEYS: "National Surveys",
    WEBINARS: "Webinars",
  };

  const renderHelperText = () => {
    if (videoData.memberVideoStatus === "Completed") {
      return `You successfully passed this assessment on ${formatDate(completedDate, "MMM D, yyyy")}.`;
    }
    if (videoData.memberVideoStatus === "Unavailable") {
      return "You have reached the maximum of 2 attempts to pass this assessment.";
    }
    return "Assessment will be available once the video has completed.";
  };
  return (
    <ScrollView testID="video-pane">
      <View className="flex px-6">
        <View className="pb-2">{renderVideoStatusChip(videoData.memberVideoStatus)}</View>
        <Text className="text-title-4 font-700 text-ink-darkest pb-4">{videoData?.title}</Text>
        <View className="flex flex-row items-center">
          <ClockIcon width={22} height={22} />
          <Text className={`text-small text-ink-dark font-normal leading-none ml-2 mt-${Platform.OS === "web" ? 0 : 1}`}>
            {videoData.duration}m
          </Text>
        </View>
        <Divider className="my-3 bg-sky-light" />
        {videoData?.publishedAt && (
          <>
            <View className="flex flex-row items-center">
              <CalendarClockIcon width={22} height={22} />
              <View className={`flex flex-row items-center mt-${Platform.OS === "web" ? 0 : 1}`}>
                <Text className="text-ink-dark text-small font-normal font-400 leading-none ml-2 flex flex-row items-center">
                  {formatDate(videoData.publishedAt, "MMMM D, YYYY")}
                </Text>
              </View>
            </View>
            <Divider className="my-3 bg-sky-light" />
          </>
        )}

        <View className="flex flex-row items-center">
          <ListIcon width={22} height={22} />
          <Text
            className={`text-ink-dark text-small font-normal font-400 leading-none ml-2 mt-${Platform.OS === "web" ? 0 : 1}`}
          >
            {videoData?.creditCategory && creditCategoryMap[videoData.creditCategory as keyof typeof creditCategoryMap]}
          </Text>
        </View>

        <Divider className="my-3 bg-sky-light" />

        <View className="flex flex-row items-center">
          <AwardIcon width={22} height={22} />
          <Text
            className={`text-ink-dark text-small font-normal font-400 leading-none ml-2 mt-${Platform.OS === "web" ? 0 : 1}`}
          >
            1 PDR Credit
          </Text>
        </View>

        <Divider className="mt-3 bg-sky-light" />
      </View>
      <View className="flex flex-col items-center">
        <Text className="text-ink-darkest text-small-normal font-normal font-400 leading-none px-12 pt-5 pb-4 text-center w-full">
          {renderHelperText()}
        </Text>
        {renderAssessmentButton(videoData.memberVideoStatus, videoData?.watchProgress?.watched, handleAssessmentPress)}
      </View>
      <Divider className={`mb-2 ${Platform.OS === "web" ? "mx-6" : ""} mt-8 bg-sky-light`} />
      <View className="flex py-4 px-6">
        <Text className="text-ink-darkest font-700 text-title-5">Description</Text>
        <Text className="text-ink-dark text-regular-normal font-normal font-400 leading-none mt-4">
          {videoData?.description}
        </Text>
      </View>
    </ScrollView>
  );
}
